// For now with the current UI design, we don't have input field for suffix yet, so it is an enum with hardcoded options
export enum EProductProperyDefinitionSuffix {
  Gb = 'GB',
  Millimeter = 'mm',
  Inch = 'INCH',
  G = 'G',
  Ounce = 'OZ',
}
